import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const ExpenseHeadingServices = {
  create: async (data) => {
    const response = await apiService.post(
      `/${slug}/header/createheader`,
      data
    );
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/header/getallheader`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/purchase/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(
      `/${slug}/header/update/${id}`,
      data
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/header/delete/${id}`);
    return response.data;
  },
};

export default ExpenseHeadingServices;
